import React, { Component } from 'react'
import $ from 'jquery'

import TextInput from '../../../textInput'
import { urlFormat, notEmpty, isValid } from '../../../validations'
import moment from 'moment';
import { createSlug } from '../../../utils'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import FileDropZone from '../../fileDropZone'
import { configs } from '../../../helpers/constants'
import { post, postFormData, get } from '../../../utils/networking'
import * as Notify from '../../../notification'
import CheckBoxes from '../checkboxes'

const validationData = {
    businessName: [notEmpty],
    businessWebsite: [notEmpty, urlFormat],
    businessPhone: [notEmpty],
    businessFacebook: [notEmpty, urlFormat],
    businessPinterest: [notEmpty, urlFormat],
    businessTwitter: [notEmpty, urlFormat],
    businessInstagram: [notEmpty, urlFormat],
    businessVideo: [notEmpty, urlFormat],
    photo: [notEmpty]
}

export default class FacilitySetting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            facilityAndAmentityDescription: "",
            facilityAndAmentityPhoto: "",
            roomAndDiningDescription: "",
            roomAndDiningPhoto: "",
            facilities: [],
            facilitiesID: [],
            amenities: [],
            amenitiesID: [],
            foodOptions: [],
            foodOptionsID: [],
            isLoaded: false
        }
    }


    onFacilityDescriptionChange(e) {
        document.getElementById("facility_validation").textContent = "";
        this.setState({
            facilityAndAmentityDescription: e.target.value
        })
    }


    onRoomDescriptionChange(e) {
        document.getElementById("room_validation").textContent = "";
        this.setState({
            roomAndDiningDescription: e.target.value
        })
    }

    onAddFacilityPhoto(file) {
        var data = new FormData()
        data.append("file", file[0])
        postFormData('upload', data, "partner", result => {
            this.setState({
                facilityAndAmentityPhoto: result
            })
        })
    }
    onAddRoomPhoto(file) {
        var data = new FormData()
        data.append("file", file[0])
        postFormData('upload', data, "partner", result => {
            this.setState({
                roomAndDiningPhoto: result
            })
        })
    }
    onRemoveFacilityPhoto() {
        this.setState({
            facilityAndAmentityPhoto: ""
        })
    }
    onRemoveRoomPhoto() {
        this.setState({
            roomAndDiningPhoto: ""
        })
    }

    handleUpdate() {
        Notify.hide();
        let param = {
            facilityAndAmentityDescription: this.state.facilityAndAmentityDescription,
            facilityAndAmentityPhoto: this.state.facilityAndAmentityPhoto,
            roomAndDiningDescription: this.state.roomAndDiningDescription,
            roomAndDiningPhoto: this.state.roomAndDiningPhoto,
            facilityIds: this.state.facilitiesID.concat(this.state.amenitiesID).concat(this.state.foodOptionsID)
        };
        post("spa/updateFacilities", param, "partner", result => {
            Notify.show($("#facility_save"), "Update success", "success", "0");
        }, errors => {
            Notify.show($("#facility_save"), errors.errors[0], "fail", "0");
        })
    }

    componentDidMount() {
        get("spa/get", "partner",
            result => {
                this.setState({
                    facilityAndAmentityDescription: result.facilityAndAmentityDescription,
                    facilityAndAmentityPhoto: result.facilityAndAmentityPhoto,
                    roomAndDiningDescription: result.roomAndDiningDescription,
                    roomAndDiningPhoto: result.roomAndDiningPhoto,
                    facilitiesID: result.facilities,
                    amenitiesID: result.amenities,
                    foodOptionsID: result.foodOptions,
                    isLoaded: this.state.isLoaded + 1
                })
            })

        get("spa/getOptions", "partner",
            result => {
                this.setState({
                    facilities: result.facilities,
                    amenities: result.amenities,
                    foodOptions: result.foodOptions,
                    isLoaded: this.state.isLoaded + 1
                })
            })

    }

    onSelectFacility(optionId) {
        let newFacilityID = this.state.facilitiesID;
        newFacilityID.push(optionId);
        this.setState({
            facilitiesID: newFacilityID
        })
    }

    onRemoveFacility(optionId) {
        let newFacilityID = this.state.facilitiesID.filter(x => x != optionId);
        this.setState({
            facilitiesID: newFacilityID
        })
    }

    onSelectAmenities(optionId) {
        let newAmenitiesID = this.state.amenitiesID;
        newAmenitiesID.push(optionId);
        this.setState({
            amenitiesID: newAmenitiesID
        })
    }

    onRemoveAmenities(optionId) {
        let newAmenitiesID = this.state.amenitiesID.filter(x => x != optionId);
        this.setState({
            amenitiesID: newAmenitiesID
        })
    }

    onSelectFoodOptions(optionId) {
        let newFoodOptionsID = this.state.foodOptionsID;
        newFoodOptionsID.push(optionId);
        this.setState({
            foodOptionsID: newFoodOptionsID
        })
    }

    onRemoveFoodOptions(optionId) {
        let newFoodOptionsID = this.state.foodOptionsID.filter(x => x != optionId);
        this.setState({
            foodOptionsID: newFoodOptionsID
        })
    }


    render() {
        let {
            facilityAndAmentityDescription,
            facilityAndAmentityPhoto,
            roomAndDiningDescription,
            roomAndDiningPhoto,
            facilities,
            facilitiesID,
            amenities,
            amenitiesID,
            foodOptions,
            foodOptionsID
        } = this.state
        let facilitPhotos = []
        facilitPhotos.push(facilityAndAmentityPhoto);
        let roomPhoto = [];
        roomPhoto.push(roomAndDiningPhoto);

        return (
            (this.state.isLoaded > 1) ? <div className="facility_setting">
                <div className="header">
                    <p>Facilities setting</p>
                </div>
                <div className="detail">
                    <div className="form-group info facility_detail">
                        <label>Facilities And Amentity</label>
                        <div className="title">Photo <span className={"text-danger"}></span>*</div>
                        <FileDropZone
                            domainUrl={configs.api_domain}
                            initFiles={facilitPhotos}
                            onAdd={this.onAddFacilityPhoto.bind(this)}
                            onRemove={this.onRemoveFacilityPhoto.bind(this)} />
                        <span className={"text-danger"} id={"validator-for-facility-photo"}></span>
                        <div className="form-group info facility">
                            <label>Description</label>
                            <textarea value={facilityAndAmentityDescription} className="facility" onChange={(value) => this.onFacilityDescriptionChange(value)}></textarea>
                            <p id="facility_validation" className="text-danger"></p>
                        </div>
                    </div>
                    {/* <div className="form-group info room_detail">
                        <label>Room And Dining</label>
                        <div className="title">Photo <span className={"text-danger"}></span>*</div>
                        <FileDropZone
                            domainUrl={configs.api_domain}
                            initFiles={roomPhoto}
                            onAdd={this.onAddRoomPhoto.bind(this)}
                            onRemove={this.onRemoveRoomPhoto.bind(this)} />
                        <span className={"text-danger"} id={"validator-for-facility-photo"}></span>
                        <div className="form-group info facility">
                            <label>Description</label>
                            <textarea value={roomAndDiningDescription} className="room" onChange={(value) => this.onRoomDescriptionChange(value)}></textarea>
                            <p id="room_validation" className="text-danger"></p>
                        </div>
                    </div> */}
                    <div className="form-group info">
                        <label>Facilities</label>
                        <CheckBoxes
                            className="facility-checkboxes"
                            options={facilities}
                            selectOptions={facilitiesID}
                            onSelect={this.onSelectFacility.bind(this)}
                            onRemove={this.onRemoveFacility.bind(this)}
                        />
                    </div>
                    <div className="form-group info">
                        <label>Amenities</label>
                        <CheckBoxes
                            className="amenities-checkboxes"
                            options={amenities}
                            selectOptions={amenitiesID}
                            onSelect={this.onSelectAmenities.bind(this)}
                            onRemove={this.onRemoveAmenities.bind(this)}
                        />
                    </div>
                    {/* <div className="form-group info">
                        <label>Food Options</label>
                        <CheckBoxes
                            className="foodOptions-checkboxes"
                            options={foodOptions}
                            selectOptions={foodOptionsID}
                            onSelect={this.onSelectFoodOptions.bind(this)}
                            onRemove={this.onRemoveFoodOptions.bind(this)}
                        />
                    </div> */}
                </div>
                <div className="form-group info submit">
                    <button className="facility_save" id="facility_save" onClick={this.handleUpdate.bind(this)}>Save</button>
                </div>
            </div > : <div>
                    <div className="spinner">
                        <div className="rect1"></div>
                        <div className="rect2"></div>
                        <div className="rect3"></div>
                        <div className="rect4"></div>
                        <div className="rect5"></div>
                    </div>
                </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/partner/facility/index.js